import Vue from 'vue'

export const getCurrentAuction = () => Vue.axios.get('auctions/current')



// WEBPACK FOOTER //
// ./src/services/auctions.js